
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ClientService } from '../../services/client.service';

import { filter } from 'rxjs/operators';
import { map } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs:any;
  public title : string
  public needsAttentionCount = 0;
  public isManagerStatusPage = false;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private clientService: ClientService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe((route:any) => {
        let snapshot = this.router.routerState.snapshot;
        let title = route.snapshot.data['title'];
        let parent = route.parent.snapshot.data['breadcrumb'];
        let child = route.snapshot.data['breadcrumb'];
        this.breadcrumbs = {};
        this.title = title;
        this.breadcrumbs = {
          "parentBreadcrumb": parent,
          "childBreadcrumb": child
        }
        this.updateNeedsAttentionBanner();
      });
  }

  ngOnInit() {
    this.updateNeedsAttentionBanner();
  }

  private updateNeedsAttentionBanner() {
    this.isManagerStatusPage = this.router.url.startsWith('/dashboard/manager-status');

    if (!this.isManagerStatusPage) {
      this.needsAttentionCount = 0;
      return;
    }

    const user = this.authService.getCurrentUser();

    this.clientService.getAllClientsByManager(user?.id ?? '').subscribe({
      next: (services: any[]) => {
        this.needsAttentionCount = (services ?? []).filter(service =>
          service.needsAttention === true || String(service.needsAttention).toLowerCase() === 'true'
        ).length;
      },
      error: () => this.needsAttentionCount = 0
    });
  }

  ngOnDestroy() {  }

}
